import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const OccurenceLocation = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();


    return (
        <SimpleBars
            title={'Local de Ocorrência'}
            horizontal={false}
            subtitles={chartData?.occurenceLocation?.map((item) => item.description)}
            values={chartData?.occurenceLocation?.map((item) => item.total  ||  0)}
        />
    );
};
